//Core
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import './style.scss';
import { API } from '../../API';
//Components
import { Authorization } from "../../components/Authorization";
import { Loader } from "../../components/Loader";
import { Main } from "../../components/voting/Main";

import { useLoc } from "../../utils/useLoc";
import { Modal } from "../../components/Modal";
import { GeneralModal } from "../../components/modals/GeneralModal";
import { FirstSession } from "../../components/modals/templatesModal/FirstSession";
//import history from "../../utils/history";

const Voting = () => {

    const [invalidAuth, setInvalidAuth] = useState(false);
    const [loadingAuth, setLoadingAuth] = useState(false);
    const [showAuthScreen, setShowAuthScreen] = useState(false);
    const [getVoting, setGetVoting] = useState(null);
    const [isFirstSession, setIsFirstSession] = useState(false);
    const [timeIsUp, setTimeIsUp] = useState(false);

    const path = useLoc();
    const history = useHistory();

    let timer = 0;

    let timerLoader = 0;

    useEffect(() => {
        getVotingRequest()
            .then((res) => {
                if (res && timeIsUp) {
                    timerLoader = setTimeout(() => {
                        setTimeIsUp(false);
                    }, 1000);
                }
            })
            .catch(() => {
                setTimeIsUp(false);
            });

        return () => {
            clearTimeout(timer);
            clearTimeout(timerLoader);
        };
    }, [timeIsUp]);

    useEffect(() => {

        if (getVoting?.voting?.status && getVoting?.voting?.status !== 'active') {
            setIsFirstSession(false);
            window.sessionStorage.setItem('instructed', 'true');
        } else {
            const instructed = Boolean(window.sessionStorage.getItem('instructed'));

            if (!instructed) {
                setIsFirstSession(true);
            }
        }

        return () => {

        };
    }, [getVoting]);

    /*    useEffect(() => {
        window.addEventListener('beforeunload', beforeUnload);
        console.log('beforeunload START');

        return () => {
            console.log('beforeunload END');
            window.removeEventListener('beforeunload', beforeUnload);
        };
    }, []);*/

    const getVotingRequest = (callback, _token) => {

        return API.get_voting_API(path, _token)
            .then((res) => {
                //console.log('res', res);
                if (callback) {
                    callback();
                }
                if (!res?.data) {
                    throw new Error('not get voting');
                }
                setGetVoting(res.data);

                return true;
            })
            .catch((e) => {
                if (e.response) {
                    //console.log('data----', e.response.data);
                    //console.log('status----', e.response.status);
                    //console.log('headers----', e.response.headers);

                    if (e.response?.data?.code === 'Unauthorized') {
                        setShowAuthScreen(true);
                    } else {
                        history.push("/");
                    }

                } else {
                    history.push("/");
                }
            })
            .finally(() => {
                setLoadingAuth(false);
            });
    };

    const onSubmitData = async (data) => {
        const getTokens = JSON.parse(window.sessionStorage.getItem('token')) || {};

        setLoadingAuth(true);

        try {
            const auth = await API.auth_API(data);

            if (!auth?.data?.access_token) {
                throw new Error('user undefined');
            }
            //console.log('auth------', auth);

            getTokens[`${path}`] = auth.data.access_token;
            //console.log('getTokens------', getTokens);
            window.sessionStorage.setItem('token', JSON.stringify(getTokens));
            await getVotingRequest();

            /*setLoadingAuth(false);
            setInvalidAuth(false);*/

            timer = setTimeout(() => {
                setShowAuthScreen(false);
            }, 500);

        } catch (e) {
            //console.log('data----', e.response.data);
            //console.log('status----', e.response.status);
            //console.log('headers----', e.response.headers);
            timer = setTimeout(() => {
                setLoadingAuth(false);
                setInvalidAuth(true);
            }, 500);

        }

    };

    /*    const beforeUnload = (e) => {
        e.preventDefault();

        return 'Ви впевнені що хочете залишити сторінку?';
    };*/

    const onCloseModal = () => {
        setIsFirstSession(false);
    };

    const onInstructed = () => {
        setIsFirstSession(false);
        window.sessionStorage.setItem('instructed', 'true');
    };

    if (showAuthScreen) {
        return (
            <div>
                <Authorization
                    invalidAuth = { invalidAuth }
                    loadingAuth = { loadingAuth }
                    onSubmitData = { onSubmitData }
                />
            </div>
        );
    }

    if (!getVoting) {
        return (
            <div className = 'loader__wrap'>
                <Loader
                    colorCircle = '#ccc'
                />
            </div>
        );
    }

    return (
        <>
            <Main path = { path } setTimeIsUp = { setTimeIsUp } votingData = { getVoting } />
            {/*<Beforeunload onBeforeunload = { () => "Ви впевнені що хочете залишити сторінку?" } />*/}
            {timeIsUp && (
                <div className = 'main-bacg-loader'>
                    <Loader
                        colorCircle = '#ccc'
                    />
                </div>
            )}
            <Modal isModal = { Boolean(isFirstSession) }>
                <GeneralModal onClose = { onCloseModal }>
                    <FirstSession
                        onClose = { onCloseModal }
                        onGotIt = { onInstructed }
                    />
                </GeneralModal>
            </Modal>
        </>
    );
};

export default Voting;
